import { isStringEmpty } from '@shared/utils';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';
import { AssistantType, ModelType } from '@shared/constants/chat';
import chatStoreManager from '@/store/chat/manager';
import appLogger from '@public/log/monitor';
import { shuffle } from 'lodash-es';
import { useConversationContext } from './context';

function WelcomeMessage(props) {
  const { msg_type,messageId, isAgent, asstInfo, agentInfo, isLocalModel } =
    props;

  let questionList =
    (isAgent
      ? agentInfo?.params?.system_info?.greeting_question
      : asstInfo?.saylist_detail) || [];

  const {
    modelInfo,
  } = useConversationContext();

  return (
    <>
      <div className="max-w-688px px-20px min-w-652px self-center mt-18px flex flex-col justify-center gap-[48px] ">
        <div className="flex flex-col gap-24px self-center">
          <div className="flex flex-col gap-16px items-center">
            <div
              className={`relative rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)] size-96px`}
            >
              <img
                className={`rounded-6.5px object-cover size-96px`}
                src={
                  modelInfo?.icon
                }
              />
              {asstInfo?.conversation_type == 1 ? (
                <img
                  className="size-12px object-cover absolute left-0 bottom-0"
                  // eslint-disable-next-line
                  src={tti_icon}
                />
              ) : null}
            </div>
            <div className="text-24px font-medium leading-24px flex items-center">
              {isAgent ? agentInfo?.params?.system_info?.name : asstInfo.title}
              {isLocalModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#0058FF] bg-[#0058FF] bg-opacity-10 rounded-4px inline-block">
                  本地
                </span>
              )}
              {asstInfo?.model_type === ModelType.APIModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#E43F9F] bg-opacity-10 bg-[#E43F9F] rounded-4px inline-block">
                  API
                </span>
              )}
              {asstInfo?.model_type === ModelType.PrivateModel && (
                <span className="w-36px height-18px leading-20px text-12px font-bold-600 text-center text-[#ff7307] bg-[#ff7307] bg-opacity-10  rounded-4px inline-block">
                  私有
                </span>
              )}
            </div>
          </div>
          <div className="text-[16px] text-center leading-28px line-clamp-2">
            {isAgent
              ? agentInfo?.params?.system_info?.greeting_message
              : asstInfo.greeting}
          </div>
        </div>
        <div className="">
          {questionList.length
            ? shuffle(questionList).map((content, index) => {
                if (index >= 3) return null;
                return (
                  <div key={`${content}_${index}`}>
                    <div
                      className={[
                        'group inline-flex items-center',
                        'h-40px mb-8px pr-18px rounded-12px overflow-hidden cursor-pointer',
                        globalStore.isDark
                          ? 'bg-secondary hover:bg-[#282832] border-[rgba(255,255,255,.1)]'
                          : 'hover:bg-gray-nav-hover',
                        'bg-gray-nav',
                      ]}
                      onClick={() => {
                        const chatStore = chatStoreManager.current;
                        const { lastMessage } = chatStore;
                        // 防止出现多个流同时回答
                        if (lastMessage.is_doing) return;
                        const { role_id, agentId } =
                          chatStore.messageMap.get(messageId);
                        chatStore.sendMessage({
                          asstId: role_id,
                          agentId,
                          input: content,
                        });

                        appLogger.log({
                          key: 'aibot_chat',
                          action: 'click',
                          arrt: 'more_question',
                          ext: content,
                          conversation_id: '',
                          message_id: messageId,
                        });

                        if (!agentId) {
                          appLogger.log({
                            key: 'aibot_chat',
                            action: 'act',
                            arrt: 'more_question',
                            ext1: modelInfo?.title,
                            role_id: role_id,
                            conversation_id: '',
                          });
                        }
                      }}
                    >
                      <div className="h-full flex items-center pr-18px flex-1">
                        <div className="h-full leading-38px pl-16px text-14px text-primary line-clamp-1 break-all">
                          {content}
                        </div>
                      </div>
                      <SVGPureIcon
                        name="arrow_right"
                        className="size-16px flex-shrink-0"
                      />
                    </div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
}

export default WelcomeMessage;
